
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 2.658c-3.76 0-6.82 3.048-6.82 6.795s3.06 6.795 6.82 6.795c3.762 0 6.822-3.048 6.822-6.795S13.262 2.658 9.5 2.658zm0 12.663c-3.25 0-5.893-2.632-5.893-5.868S6.25 3.585 9.5 3.585s5.894 2.632 5.894 5.868-2.644 5.868-5.894 5.868z"}}),_c('path',{attrs:{"d":"M9.5 0C4.269 0 .01 4.24.01 9.453c0 1.902.492 3.837 1.461 5.75.768 1.516 1.836 3.022 3.175 4.476 2.271 2.467 4.51 3.916 4.604 3.976a.463.463 0 00.501 0c.094-.06 2.333-1.51 4.604-3.976 1.34-1.454 2.407-2.96 3.175-4.476.97-1.913 1.46-3.848 1.46-5.75C18.99 4.241 14.735 0 9.5 0zm4.188 19.035a26.478 26.478 0 01-4.187 3.67 26.474 26.474 0 01-4.188-3.67C3.317 16.863.937 13.437.937 9.453.937 4.752 4.78.927 9.501.927s8.563 3.825 8.563 8.526c0 3.984-2.38 7.41-4.376 9.582z"}}),_c('path',{attrs:{"d":"M12.696 8.154l-1.77-.522L9.883 6.11a.463.463 0 00-.765 0L8.075 7.632l-1.77.522a.464.464 0 00-.236.727l1.125 1.462-.05 1.844a.463.463 0 00.618.45l1.739-.618 1.738.618a.463.463 0 00.619-.45l-.051-1.844 1.125-1.462a.464.464 0 00-.236-.727zm-1.724 1.754a.463.463 0 00-.096.296l.036 1.333-1.256-.447a.464.464 0 00-.31 0l-1.257.447.037-1.333a.463.463 0 00-.096-.296l-.814-1.056 1.28-.378a.463.463 0 00.25-.182l.755-1.1.754 1.1c.06.088.149.152.25.182l1.28.378-.813 1.056z"}})])
          )
        }
      }
    